import { createReducer } from '/@/store/utils';
import {
    closeWalkthroughSlides,
    resetConversion,
    setConversion,
    setCountry,
    setLanguage,
    setNitrogenRecommendationEnabled,
    setPreferences,
    setReceiveNotifications,
    setReceiveWhatsappNotifications,
    setToken,
    setUnits,
    setUser,
} from './actions';

const initial = {
    authenticated: false,
    user: undefined,
    conversion: {},
    ...(typeof window !== 'undefined' ? window.INITIAL_SESSION || {} : {}),
    token: undefined,
};

export default createReducer(initial, {
    [setUser]: (state, action) => ({
        ...state,
        user: action.payload,
        authenticated: Boolean(action.payload),
    }),
    [setCountry]: (state, action) => ({ ...state, country: action.payload }),
    [setLanguage]: (state, action) => ({ ...state, language: action.payload }),
    [setUnits]: (state, action) => ({ ...state, units: action.payload }),
    [setReceiveNotifications]: (state, action) => ({ ...state, receiveNotifications: action.payload }),
    [setReceiveWhatsappNotifications]: (state, action) => ({ ...state, receiveWhatsappNotifications: action.payload }),
    [closeWalkthroughSlides]: (state, action) => ({ ...state, showSlides: action.payload }),
    [setConversion]: (state, action) => ({ ...state, conversion: action.payload }),
    [resetConversion]: (state) => ({ ...state, conversion: initial.conversion }),
    [setNitrogenRecommendationEnabled]: (state, action) => ({
        ...state,
        nitrogenRecommendationEnabled: action.payload,
    }),
    [setToken]: (state, action) => ({ ...state, token: action.payload }),
    [setPreferences]: (state, action) => ({ ...state }),
});
